import { Service } from '@roc/feature-app-core';
import { LienRow } from '../types';

const url = {
  GET_SCREEN_DATA: `/api/v1/doc-review/title-commitment/screen`,
  GET_LIEN_BY_TASK_ID: `/api/v1/doc-review/liens/getLienByTaskId`,
  SAVE_LIEN: `/api/v1/doc-review/liens/saveLien`,
  ASSIGN_PROPERTY: `/api/v1/doc-review/liens/assignProperty`,
  DELETE_LIEN_DOCUMENT: `/api/v1/doc-review/liens/deleteLienDocument`,
  CREATE_RESOLUTION: `/api/v1/doc-review/liens/createResolution`,
  UPDATE_TAX: `/api/v1/doc-review/title-commitment/updateTax`,
};

export class TitleCommitmentService extends Service {

  getScreenData(taskId: number) {
    return this.get(url.GET_SCREEN_DATA, { taskId });
  }

  getLienByTaskId(taskId: number) {
    return this.get(url.GET_LIEN_BY_TASK_ID, { taskId });
  }

  saveLien(lien: LienRow) {
    return this.post(url.SAVE_LIEN, lien);
  }

  assignProperty(lienId: number, propertyId: number) {
    return this.put(url.ASSIGN_PROPERTY, { lienId, propertyId });
  }

  deleteLienDocument(taskId: number) {
    return this.delete(url.DELETE_LIEN_DOCUMENT, { taskId });
  }

  createResolution(lienId: number) {
    return this.get(url.CREATE_RESOLUTION, { lienId });
  }

  updateTax(payload: {
    taskId: number;
    loanId: number;
    propertyId: number;
    recordIndex: number;
    annualTaxAmount: number;
    propertyAddress: string;
  }) {
    return this.post(url.UPDATE_TAX, payload);
  }

}
